import { types, actions } from './requests'
export const MERGEMATERIAL_TYPES = {
    ...types('MERGEMATERIAL'),
}
export const MERGEMATERIAL_ACTIONS = {
    ...actions('MERGEMATERIAL'),
}